import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import { AssetItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';
import { useLinkPreviewMediaData } from '@/components/pages/SituationalAwareness/hooks/useLinkPreviewMediaData';
import { TargetCard, TargetCardProps } from '../TargetCard';

export interface TargetAssetInfoProps {
  target: Pick<
    AssetItem,
    | 'AssetID'
    | 'AssetType'
    | 'AssetName'
    | 'Country'
    | 'Address'
    | 'FocalPointEmail'
    | 'FocalPointName'
    | 'FocalPointPhone'
    | 'Photo'
    | 'Hyperlink'
    | 'ReportLink'
    | 'Latitude'
    | 'Longitude'
    | 'AssetDescription'
    | 'SupplyChainMapping'
    | '_targetType'
  >;
  actions?: React.ReactNode;
}

export const TargetAssetInfoView: React.FC<TargetAssetInfoProps> = ({ target, actions }) => {
  const { data, isLoading } = useLinkPreviewMediaData({ link: target.Hyperlink, enabled: !target.Photo });
  const contactData = useMemo<TargetCardProps['details']['contact']>(() => {
    return {
      ...(target.FocalPointEmail && { email: target.FocalPointEmail }),
      ...(target.FocalPointName && { name: target.FocalPointName }),
      ...(target.FocalPointPhone && { phone: target.FocalPointPhone }),
    };
  }, [target]);

  return (
    <>
      <TargetCard
        className="!p-0"
        details={{
          addressName: target.Address,
          contact: contactData,
        }}
        isDetailsShow={!!target.Address || !isEmpty(contactData)}
        incident={null}
        imageSrc={target.Photo || data?.imageSrc}
        isMediaLoading={isLoading}
        link={target.Hyperlink}
        reportLink={target.ReportLink}
        description={target.AssetDescription}
      />
      {actions}
    </>
  );
};
